import React, { ChangeEvent, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { Button, Form, ModalBody } from 'react-bootstrap';
import { FadeIn, FloatingField } from '../Global/Transitions';
import { CreateConversation, Savefeedback } from '../../Services/PtaasApiService';
import { SuccessIcon } from '../Global/Icons';
import Feedback from '../Global/Feedback';



const Completion: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [giveFeedback, setGiveFeedback] = useState(false);
  const [rating, setRating] = useState(0); // State to store rating
  const [comment, setComment] = useState(''); // Lifted state for feedback
  const { instance, accounts } = useMsal();

  const props = {
    title: 'Conversation Created',
    text: 'Congratulations! Your new conversation has been created successfully.'
  };

  const handleFeedback = () => setGiveFeedback(true);

  // Save feedback when "Continue" is clicked
  const handleContinue = async () => {
    if (giveFeedback) {
      try {
        await Savefeedback(instance, accounts[0], null, comment, rating); // Actual API call
      } catch (error) {
        console.error('Error saving feedback:', error);
      }
    }

    onClose(); // Close the modal or perform the completion action
    window.location.reload();
  };

  return (
    <FadeIn>
      <div className="text-center py-5">
        <SuccessIcon />
        <h1 className="m-0">{props.title}</h1>
        <p>{props.text}</p>
        {giveFeedback && (
          <Feedback
            rating={rating}
            comment={comment}
            setRating={setRating}
            setComment={setComment}
          />
        )}
        {!giveFeedback && (
          <Button onClick={handleFeedback} variant="outline-primary" className="me-3">
            Give Feedback
          </Button>
        )}
        <Button onClick={handleContinue}>Continue</Button> 
      </div>
    </FadeIn>
  );
};

interface EditChatProps {
  onChange?: () => void; 
  onClose?: () => void; 
}

const EditChat: React.FC<EditChatProps> = ({ onChange, onClose }) => {
  const { instance, accounts } = useMsal();
  const [validated, setValidated] = useState(false);
  const [, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [completed, setCompleted] = useState(false);

  const handleCreate = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();
    try {
      await CreateConversation(instance, accounts[0], title, null);
      setValidated(true);
      onChange?.(); // Trigger the onChange callback
      onClose?.(); // Close the modal
      setCompleted(true); // Show completion state
    } catch (err: any) {
      setError(err?.message || 'An unexpected error occurred while creating the user.');
    } finally {
      setLoading(false);
      // console.log(error);
    }
  };

  return (
    <ModalBody>
      {completed ? (
        <Completion onClose={() => { setCompleted(false); onClose?.(); }} />
      ) : (
        <FadeIn>
          <Form noValidate validated={validated} onSubmit={handleCreate} >
            <FloatingField
              main
              label="Title"
              type="text"
              value={title}
              onChange={(e: ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)}
              required
            />
            <Form.Group className="mt-4 d-flex justify-content-between">
              <Button className="me-3" onClick={() => setCompleted(false)} variant={'outline-secondary'}>
                Cancel
              </Button>
              <Button type="submit" disabled={loading}>
                Submit
              </Button>
            </Form.Group>
          </Form>
        </FadeIn>
      )}
    </ModalBody>
  );
};


export default EditChat;


